
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M286.17 256l90.512-90.512a21.324 21.324 0 005.52-20.605 21.334 21.334 0 00-15.082-15.086 21.335 21.335 0 00-20.61 5.523l-90.507 90.508-90.508-90.508a21.336 21.336 0 00-20.61-5.523 21.334 21.334 0 00-15.081 15.086 21.324 21.324 0 005.519 20.605L225.835 256l-90.512 90.508a21.336 21.336 0 009.563 35.695 21.335 21.335 0 0020.609-5.523l90.508-90.512 90.508 90.512a21.336 21.336 0 0035.695-9.563 21.335 21.335 0 00-5.524-20.609z","fill":"currentColor"}})])
          )
        }
      }
    